module.exports = __webpack_public_path__ + "img/logo.ffb0ea6c.png";